import React, { useEffect } from "react";

const RegisterConfirm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="forgot-text">
      <h1 className="forgot-title">
        The account has been{" "}
        <span className="forgot-blue-text">successfully</span> created.
      </h1>
      <h3 className="forgot-desc">
        <span className="forgot-gray-text">
          we will send login details to your e-mail after your account has been
          approved.
        </span>
      </h3>
    </div>
  );
};

RegisterConfirm.displayName = "Confirmation";

export default RegisterConfirm;
